import { PrivateChatsContext } from "hhn-commons";
import { useContext } from "react";
import { Divider } from "@mui/material";
import { GroupChatListPanelHeader } from "../GroupChatListPanelHeader";
import { PrivateChatList } from "./PrivateChatList";
import { GroupChatListPanelHeaderWrapper } from "../group/patient/PatientChats.styles";

interface PrivateChatListPanelProps {
  selectedChatId?: string;
  unreadChatCount: number;
}

export const PrivateChatListPanel = ({
  selectedChatId,
  unreadChatCount,
}: PrivateChatListPanelProps) => {
  const { chatData, fetchChats, isChatLoading } =
    useContext(PrivateChatsContext);

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={unreadChatCount}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <PrivateChatList
        chats={chatData?.chats || []}
        isChatLoading={isChatLoading}
        selectedChatId={selectedChatId}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
